
/* Baby Pandas — Title OR Tag storefront search */
(() => {
  'use strict';

  function buildQuery(value) {
    const words = value
      .normalize('NFKC')
      .trim()
      .split(/\s+/)
      .map(word => word.replace(/[^\p{L}\p{N}]/gu, ''))
      .filter(Boolean)
      .slice(0, 8);

    return words.map(word =>
      `(title:${word}* OR tag:${word}*)`
    ).join(' AND ');
  }

  // Make the query builder available to Ella's
  // View All Results function.
  window.bpBuildSearchQuery = buildQuery;

  // Intercept standard search form submissions.
  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const action = new URL(form.action, window.location.origin);

    if (!action.pathname.endsWith('/search')) return;

    const input = form.querySelector('[name="q"]');
    if (!input || !input.value.trim()) return;

    // Avoid converting a query that is already field-scoped.
    if (/^(?:\(|title:|tag:)/i.test(input.value.trim())) return;

sessionStorage.setItem(
  'bpLastSearchPhrase',
  input.value.trim()
);

    const query = buildQuery(input.value);

    if (!query) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const destination = new URL(form.action, window.location.origin);

    destination.searchParams.set('q', query);
    destination.searchParams.set('type', 'product');
    destination.searchParams.set('options[prefix]', 'none');

    window.location.assign(destination.toString());
  }, true);
  
// Show the customer's original words in the search box,
// rather than Shopify's internal Title OR Tag query.
function restoreSearchDisplay() {
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q') || '';

  if (!query.includes('title:') || !query.includes('tag:')) {
    return;
  }

  const savedPhrase = sessionStorage.getItem('bpLastSearchPhrase');

  if (!savedPhrase) return;

  document.querySelectorAll('input[name="q"]').forEach(input => {
    if (input.value.includes('title:') || input.value.includes('tag:')) {
      input.value = savedPhrase;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', restoreSearchDisplay);
} else {
  restoreSearchDisplay();
}

})();
